<template>
    <div class="dataAny3" v-if="isshow">
        <!--学习效率-->
        <div class="data_box">
            <div class="dataTitle">
                <span><b></b>学习效率</span>
            </div>
            <div class="grayBg">
                <div class="gray_box">
                    <p>总学习人数</p>
                    <p>{{summarymap.studydecount}}</p>
                </div>
                <div class="gray_box">
                    <p>总完成数</p>
                    <p>{{summarymap.finishstudycount}}</p>
                </div>
                <div class="gray_box">
                    <p>完课率累计</p>
                    <p>{{summarymap.finishstudyrate}}</p>
                </div>
            </div>
        </div>
        <!--学习趋势图-->
        <div class="data_box">
            <div class="filters">
                <div class="dataTitle"><span><b></b>学习趋势图</span></div>
                <div class="search">
                    <p class="dateSearch">时间筛选</p>
                    <el-button type="text" @click="handleQuery(1)" :class="[timetype!=1?'textBtn': 'activeText']">近7天</el-button>
                    <el-button type="text" @click="handleQuery(2)" :class="[timetype!=2?'textBtn': 'activeText']">近30天</el-button>
                    <el-date-picker class="dateInput" v-model="date" type="daterange" align="right" unlink-panels
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                    </el-date-picker>
                    <el-button type="primary" plain @click="handleQuery(0)">搜索</el-button>
                </div>
            </div>
            <div class="echarts">
                <div class="echartsTitle">
                    <span>学习人数 <i class="blue"></i></span>
                    <span><i></i> 人均学习时长(分钟) </span>
                </div>
                <LineAndBar :lineBarDatas="lineBarDatas"></LineAndBar>
            </div>
        </div>
        <!--完课率趋势图-->
        <div class="data_box">
            <div class="filters">
                <div class="dataTitle"><span><b></b>完课率趋势图</span></div>
                <div class="search">
                    <p class="dateSearch">时间筛选</p>
                    <el-button type="text" @click="handleQuery1(1)" :class="[timetype1!=1?'textBtn': 'activeText']">近7天</el-button>
                    <el-button type="text" @click="handleQuery1(2)" :class="[timetype1!=2?'textBtn': 'activeText']">近30天</el-button>
                    <el-date-picker class="dateInput" v-model="date" type="daterange" align="right" unlink-panels
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                    </el-date-picker>
                    <el-button type="primary" plain @click="handleQuery1(0)">搜索</el-button>
                </div>
            </div>
            <div class="echarts">
                <div class="echartsTitle">
                    <span>完成学习人数 <i class="blue"></i></span>
                    <span><i></i> 完课率 </span>
                </div>
                <LineAndBar :lineBarDatas="lineBarDatas2"></LineAndBar>
            </div>
        </div>
    </div>
</template>

<script>
    import {getLearningTrendChart,getFinishRateChart} from 'api/curriculumApi'
    import LineAndBar from 'base/echarts/lineAndBar'
    import {mapActions} from 'vuex'
    import {dateFormat2} from 'common/js/tools'
    export default {
        name: "dataAny3",
        data(){
            return{
                date: [],
                isshow:false, // 是否显示页面
                param: {
                    courseid:this.$route.query.innerid?this.$route.query.innerid:'',
                    begintime: '',
                    endtime: '',
                },
                timetype:1, //时间类型
                timetype1:1, //时间类型2
                summarymap:{},
                init: false,
                lineBarDatas: {
                    id: 'studyData',
                    xdata: [],
                    data: [],
                    dataBar: [],
                    legendAddr: 'left', formatter: '{a0}: {c0}'
                },
                lineBarDatas2: {
                    id: 'finishData',
                    xdata: [],
                    data: [],
                    dataBar: [],
                    legendAddr: 'left',
                    // formatter: '{a0}: {c0}',
                },
            }
        },
        mounted(){
            this.sevenDays()
            this.getInfo()
            this.getInfoFinish()
        },
        methods:{
            // 获取学习趋势图
            getInfo(){
                this.setLoading(true)
                getLearningTrendChart({
                    data: Object.assign({}, this.param),
                    success: data => {
                        this.setLoading(false)
                        this.isshow=true
                        this.summarymap=data.data.summarymap
                        this.lineBarDatas.xdata=data.data.xdata
                        this.lineBarDatas.dataBar.list =  data.data.studydecountYdata
                        this.lineBarDatas.dataBar.title =  '学习人数'
                        this.lineBarDatas.dataBar.color = '#5B8FF9'
                        this.lineBarDatas.data.list =  data.data.studydetimesYdata
                        this.lineBarDatas.data.title =  '人均学习时长(分钟)'
                        this.lineBarDatas.data.color = '#5AD8A6'
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            // 获取完课率趋势图
            getInfoFinish(){
                this.setLoading(true)
                getFinishRateChart({
                    data: Object.assign({}, this.param),
                    success: data => {
                        this.setLoading(false)
                        this.isshow=true
                        this.lineBarDatas2.xdata=data.data.xdata
                        this.lineBarDatas2.dataBar.list =  data.data.finishstudyYdata
                        this.lineBarDatas2.dataBar.title =  '完成学习人数'
                        this.lineBarDatas2.dataBar.color = '#5B8FF9'
                        this.lineBarDatas2.data.list =  data.data.classrateYdata
                        this.lineBarDatas2.data.title =  '完课率'
                        this.lineBarDatas2.data.color = '#5AD8A6'
                        // this.lineBarDatas2.dataBar.push({
                        //     title: '完成学习人数',
                        //     color: '#5B8FF9',
                        //     list: data.data.finishstudyYdata
                        // })
                        // this.lineBarDatas2.data.push({
                        //     title: '完课率',
                        //     color: '#5AD8A6',
                        //     list: data.data.classrateYdata
                        // })
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            // 最近7天
            sevenDays(){
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
                this.param.begintime=dateFormat2(start)
                this.param.endtime=dateFormat2(end)
            },
            // 最近30天
            thridDays(){
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
                this.param.begintime=dateFormat2(start)
                this.param.endtime=dateFormat2(end)
            },
            handleQuery(index) {
                if(index===1){
                    this.sevenDays()
                    this.getInfo()
                }else if(index===2){
                    this.thridDays()
                    this.getInfo()
                }else{
                    this.param.begintime = this.date[0]
                    this.param.endtime = this.date[1]
                    this.getInfo()
                }
                this.timetype=index
            },
            handleQuery1(index){
                if(index===1){
                    this.sevenDays()
                    this.getInfoFinish()
                }else if(index===2){
                    this.thridDays()
                    this.getInfoFinish()
                }else{
                    this.param.begintime = this.date[0]
                    this.param.endtime = this.date[1]
                    this.getInfoFinish()
                }
                this.timetype1=index
            },
            ...mapActions([
                'setLoading',
            ])
        },
        components:{
            LineAndBar
        }
    }
</script>

<style lang="scss">
    .dataAny3{
        .data_box{
            .dataTitle{
                font-size: 16px;
                font-weight: bold;
                span{
                    display: flex;
                    align-items: center;
                    b{
                        width: 2px;
                        height: 12px;
                        background: #409EFF;
                        margin-right: 5px;
                    }
                }
            }
            .grayBg{
                width: 100%;
                height: 140px;
                background: #F5F7FA;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 20px;
                .gray_box{
                    flex: 1;
                    padding: 0 30px;
                    border-right: 1px solid #DCDFE6;
                    p{
                        font-size: 42px;
                        line-height: 48px;
                    }
                    p:first-child{
                        font-size: 16px;
                    }
                }
                .gray_box:last-child{
                    border-right: none;
                }
            }
            .filters{
                margin: 20px 0;
                .search{
                    display: flex;
                    .dateSearch{
                        margin-right: 10px;
                    }
                    .el-date-editor--daterange.el-input__inner{
                        width: 220px;
                        padding: 0 10px;
                        margin: 0 10px;
                    }
                    .textBtn, .el-button--mini{
                        min-width: 60px;
                        color: #303133;
                    }
                    .activeText, .el-button--mini{
                        min-width: 60px;
                        color: #409EFF;
                    }
                }
            }
            .echarts{
                .echartsTitle{
                    display: flex;
                    font-size: 14px;
                    color: #333;
                    justify-content: space-between;
                    padding: 0 10px;
                    i{
                        width: 8px;
                        height: 8px;
                        border-radius: 50%;
                        background: #5AD8A6;
                        display: inline-block;
                    }
                    .blue{
                        background: #5B8FF9
                    }
                }
            }
        }
    }
</style>
